import type { DateTimeFilter } from '../types';

import { getDateTimeFilterMapping, MainDateTimePickerAlias } from '../constants';
import { dayjsTzToLocalTZ } from '~/utils/dayjs';

export const useDateTimeFilter = () => {
  const currentDate = dayjsTzToLocalTZ().startOf('day');
  const mappings = getDateTimeFilterMapping();

  const TODAY_CONFIG = mappings[MainDateTimePickerAlias.TODAY];
  const TODAY_DATE_RANGE = {
    ...TODAY_CONFIG,
    ...TODAY_CONFIG.getDateRange(currentDate),
  };

  const YESTERDAY_CONFIG = mappings[MainDateTimePickerAlias.YESTERDAY];
  const YESTERDAY_DATE_RANGE = {
    ...YESTERDAY_CONFIG,
    ...YESTERDAY_CONFIG.getDateRange(currentDate),
  };

  const LAST_7_DAYS_CONFIG = mappings[MainDateTimePickerAlias.LAST_7_DAYS];
  const LAST_7_DAYS_DATE_RANGE = {
    ...LAST_7_DAYS_CONFIG,
    ...LAST_7_DAYS_CONFIG.getDateRange(currentDate),
  };

  const LAST_30_DAYS_CONFIG = mappings[MainDateTimePickerAlias.LAST_30_DAYS];
  const LAST_30_DAYS_DATE_RANGE = {
    ...LAST_30_DAYS_CONFIG,
    ...LAST_30_DAYS_CONFIG.getDateRange(currentDate),
  };

  const LAST_90_DAYS_CONFIG = mappings[MainDateTimePickerAlias.LAST_90_DAYS];
  const LAST_90_DAYS_DATE_RANGE = {
    ...LAST_90_DAYS_CONFIG,
    ...LAST_90_DAYS_CONFIG.getDateRange(currentDate),
  };

  const LAST_365_DAYS_CONFIG = mappings[MainDateTimePickerAlias.LAST_365_DAYS];
  const LAST_365_DAYS_DATE_RANGE = {
    ...LAST_365_DAYS_CONFIG,
    ...LAST_365_DAYS_CONFIG.getDateRange(currentDate),
  };

  const LAST_MONTH_CONFIG = mappings[MainDateTimePickerAlias.LAST_MONTH];
  const LAST_MONTH_DATE_RANGE = {
    ...LAST_MONTH_CONFIG,
    ...LAST_MONTH_CONFIG.getDateRange(currentDate),
  };

  const LAST_12_MONTHS_CONFIG = mappings[MainDateTimePickerAlias.LAST_12_MONTHS];
  const LAST_12_MONTHS_DATE_RANGE = {
    ...LAST_12_MONTHS_CONFIG,
    ...LAST_12_MONTHS_CONFIG.getDateRange(currentDate),
  };

  const LAST_YEAR_CONFIG = mappings[MainDateTimePickerAlias.LAST_YEAR];
  const LAST_YEAR_DATE_RANGE = {
    ...LAST_YEAR_CONFIG,
    ...LAST_YEAR_CONFIG.getDateRange(currentDate),
  };

  const DATE_TIME_FILTERS: DateTimeFilter[] = [
    TODAY_DATE_RANGE,
    YESTERDAY_DATE_RANGE,
    LAST_7_DAYS_DATE_RANGE,
    LAST_30_DAYS_DATE_RANGE,
    LAST_90_DAYS_DATE_RANGE,
    LAST_365_DAYS_DATE_RANGE,
    LAST_MONTH_DATE_RANGE,
    LAST_12_MONTHS_DATE_RANGE,
    LAST_YEAR_DATE_RANGE,
  ];

  return {
    DATE_TIME_FILTERS,
    LAST_7_DAYS_DATE_RANGE,
    LAST_30_DAYS_DATE_RANGE,
  };
};
